import { AppState } from 'store';
import { ChatState } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getChat = (state: AppState): ChatState => state.chat;
